export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormRegister.vue?vue&type=template&id=4873afb6&"


//////////////////
// WEBPACK FOOTER
// ./src/components/login/FormRegister.vue?vue&type=template&id=4873afb6&
// module id = 917
// module chunks = 0